import { extendObservable, runInAction } from 'mobx';

import { FAQsController } from '../../../../networking/controllers/FAQsController';
import { Logger } from '../../../../helpers/Logger';
import { Recaptcha } from '../../../../helpers/Recaptcha';

class ContactStoreClass {
  constructor() {
    extendObservable(this, {
      submitError: false,
      submitting: false,
      submitSuccess: false,
    });
  }

  async create(data) {
    runInAction(() => {
      this.submitError = false;
      this.submitSuccess = false;
    });
    try {
      runInAction(() => {
        this.submitting = true;
      });
      await FAQsController.create(data);
      runInAction(() => {
        this.submitSuccess = true;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.submitError = true;
      });
    } finally {
      runInAction(() => {
        this.submitting = false;
      });
      Recaptcha.reset();
    }
  }

  clearSubmitStates() {
    runInAction(() => {
      this.submitError = false;
      this.submitSuccess = false;
    });
  }
}

const ContactStore = new ContactStoreClass();

export { ContactStore };



// WEBPACK FOOTER //
// ./src/pages/information/contact/stores/ContactStore.js